import React, { FC } from 'react';
import { ServiceDataMoment } from '../../Analytics/Service/AnalyticsServiceGrid';
import { OParagraph } from '@lifechurch/react-ion';

interface Props {
  moment: ServiceDataMoment;
}

const QuoteMomentDetail: FC<Props> = ({ moment }) => {
  return <OParagraph>{moment.content}</OParagraph>;
};

export default QuoteMomentDetail;
